import styled from 'styled-components'

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem 0;
  border: 1px solid ${({ theme }) => theme.gray};
  padding: 1rem;
  box-shadow: 0 0 20px ${({ theme }) => theme.gray};
`

export const CardTitle = styled.strong`
  border-bottom: 1px solid ${({ theme }) => theme.gray};
  padding: 0 1rem;
  margin: 0 -1rem .5rem;
  align-self: stretch;
`

export const CardText = styled.div`
  margin: .5rem 0;
`

export const CardImage = styled.img`
  max-width: 100%;
  align-self: center;
`